import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { importByPageList } from "../importPages";

import AddLocation from "./Pages/AddLocation";
import ChangeLocation from "./Pages/ChangeLocation";
import EditLocation from "./Pages/EditLocation";
import SelectTenant from "./Pages/SelectTenant";
import FilterTenant from "./Pages/FilterTenant";

import UserService from "../../../services/UserService";
import { getTenantText } from "../../../utils/translationHelpers";
import Button from "../../Reusable/Button";
import { IButtonAction, handleRedirect } from "../../../utils/CommonFunctions";

// Map route paths to components
export const ROUTES = {
  ADD_LOCATION: { path: "/LOCATION_SELECTION/AddLocation", component: AddLocation },
  CHANGE_LOCATION: { path: "/LOCATION_SELECTION/ChangeLocation", component: ChangeLocation },
  EDIT_LOCATION: { path: "/LOCATION_SELECTION/EditLocation", component: EditLocation },
  SELECT_TENANT: { path: "/LOCATION_SELECTION/SelectTenant", component: SelectTenant },
  FILTER_TENANT: { path: "/LOCATION_SELECTION/FilterTenant", component: FilterTenant },
};

const LOCATION_SELECTION = () => {
  const [t] = useTranslation("translations");
  const history = useNavigate();

  const [address] = useState(UserService.getAttribute("savedLocationTenant"));

  let title = "",
    distance = 0;

  let LocationTextView: React.FC = function LocationTextView() {
    return <div />;
  };

  if (address?.type === "location") {
    const { city, postalcode } = address.address;
    title = city;
    distance = address.distance;

    LocationTextView = function LocationTextView() {
      return (
        <>
          <p className="ls__locationtitle">{title}</p>
          <p className="ls__locationsubtitle">
            {postalcode} +{distance} km
          </p>
        </>
      );
    };
    LocationTextView.displayName = "LocationTextViewLocation";
  } else if (address?.type === "tenant") {
    title = address.name;

    LocationTextView = function LocationTextView() {
      return (
        <>
          <p className="ls__locationtitle">{title}</p>
        </>
      );
    };
  }
  
  const handleButtonClick = () => {
    const button_action: IButtonAction = {
      type: "IN_APP",
      url: `${window.location.origin}${ROUTES.CHANGE_LOCATION.path}`,
    }
    const pageName = "";
    const title = "";
    handleRedirect(button_action, history, title, pageName);
  };

  return (
    <div className="ls__index">
      <div className="ls__locationbox">
        {address?.position !== undefined ? (
          <LocationTextView />
        ) : (
          <p className="ls__locationtitle">{t("LocationSelection.location_title")}</p>
        )}
      </div>
      <Button
        buttonType="IN_APP"
        buttonClassname="ls__link"
        buttonText={address?.position !== undefined
          ? t("LocationSelection.location_link--hydrated", { tenant: getTenantText("tenant").toUpperCase() })
          : t("LocationSelection.location_link")}
        handleRedirect={(()=> handleButtonClick())}
        showButtonIcon={false}
        buttonIconImage=""
        buttonIconClassname=""
        buttonIconPosition=""
      />
    </div>
  );
};

LOCATION_SELECTION.displayName = "LOCATION_SELECTION";

export default LOCATION_SELECTION;

export const LocationSelectionConfig = () =>
  importByPageList(LOCATION_SELECTION.displayName, Object.values(ROUTES).map(route=> route.component));